export const canToggleDeliverableCompletion = ({
	isComplete,
	statusResolved,
	isImmutable,
}: {
	isComplete: boolean;
	statusResolved: boolean;
	isImmutable: boolean;
}) => !isComplete || (statusResolved && !isImmutable);
